// project import
import support from './support';
import propertyFinder from './property';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [propertyFinder, support]
};

export default menuItems;
